var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { safeElement } from "../../../utils";
import { Typography } from "../../Typography";

var FieldLabel = forwardRef(function (_ref, ref) {
  var id = _ref.id,
      htmlFor = _ref.htmlFor,
      label = _ref.label,
      secondaryLabel = _ref.secondaryLabel,
      tertiaryLabel = _ref.tertiaryLabel,
      labelSize = _ref.labelSize,
      restProps = _objectWithoutProperties(_ref, ["id", "htmlFor", "label", "secondaryLabel", "tertiaryLabel", "labelSize"]);

  return React.createElement(
    Wrapper,
    null,
    React.createElement(
      Label,
      _extends({
        htmlFor: htmlFor,
        forwardedRefSafe: ref,
        $as: "label"
      }, restProps),
      React.createElement(
        Typography,
        { $as: "span", size: labelSize },
        label
      ),
      secondaryLabel && React.createElement(
        Typography,
        {
          $as: "span",
          color: "textSoft",
          size: labelSize,
          style: {
            display: "inline",
            marginLeft: "0.25rem"
          }
        },
        "(",
        secondaryLabel,
        ")"
      )
    ),
    tertiaryLabel ? tertiaryLabel : null
  );
});

export { FieldLabel };
FieldLabel.displayName = "FieldLabel";

FieldLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  htmlFor: PropTypes.string.isRequired
} : {};

var Label = styled(safeElement()).withConfig({
  displayName: "FieldLabel__Label",
  componentId: "sc-7gm0hu-0"
})(["display:flex;"]);

var Wrapper = styled.div.withConfig({
  displayName: "FieldLabel__Wrapper",
  componentId: "sc-7gm0hu-1"
})(["display:flex;justify-content:space-between;align-items:center;"]);